import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { AssetsModule, icons } from '@tsq-web/assets';

import { PasswordRequirement } from '../../models/password-requirement';

@Component({
  standalone: true,
  imports: [TranslateModule, AssetsModule, NgFor, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'comm-password-requirements',
  template: `
    <span class="block">{{ 'PASSWORD.REQUIREMENTS.MUST_HAVE' | translate }}</span>
    <div *ngFor="let requirement of requirements" class="flex gap-4">
      <tsq-icon
        *ngIf="showIcon"
        [classes]="'size-16 ' + (requirement.hasError ? 'text-red' : 'text-new-primary')"
        [icon]="requirement.hasError ? icons.xmark : icons.check"
      />
      <span>{{ requirement.message | translate }}</span>
    </div>
  `,
})
export class PasswordRequirementsComponent {
  @Input() requirements: PasswordRequirement[] = [];
  @Input() showIcon = false;

  readonly icons = icons;
}
